import { useBrandPlanSchedules, Props, Options } from 'hooks/queries/schedules/useBrandPlanSchedules'
import { Response } from 'request-dot-js'
import { TransformedBrandPlanSchedule } from 'screens/BrandKits/components/BrandPlanTimeline/Types'
import { BrandPlanSchedule } from 'types'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'

dayjs.extend(isBetween)
dayjs.extend(isSameOrBefore)

export const transformSchedule = <S extends BrandPlanSchedule = BrandPlanSchedule>(
  schedule: S,
): TransformedBrandPlanSchedule<S> => {
  const startDate = dayjs(schedule.start_date)
  const endDate = startDate.add(schedule.length, 'week').subtract(1, 'day').endOf('day')

  return {
    ...schedule,
    startDate,
    endDate,
    approvalDate: schedule.approval_date ? dayjs(schedule.approval_date) : undefined,
    createdAt: dayjs(schedule.created_at),
  }
}

export const useTransformedBrandPlanSchedules = (
  props: Props,
  options?: Omit<Options<Response<{ schedules: TransformedBrandPlanSchedule[] }>>, 'select'>,
) =>
  useBrandPlanSchedules<Response<{ schedules: TransformedBrandPlanSchedule[] }>>(props, {
    select: (data) => {
      return {
        ...data,
        pages: data.pages.map((page) => ({
          ...page,
          data: {
            ...page.data,
            schedules: page.data.schedules.map(transformSchedule),
          },
        })),
      }
    },
    ...options,
  })
